// extracted by mini-css-extract-plugin
export default {"footerContainer":"ButtonsFooter_footerContainer__OKqCc","footer":"ButtonsFooter_footer__pscDX"};